import { useTranslation } from "react-i18next";

import { BackgroundImage, Button, Center, Container, Image, Stack, Text, Title, useMantineTheme } from "@mantine/core";

import promoImage from "@/assets/promo/WAKU-Care-Promo.png";
import { SYSTEM_COLORS } from "@/configs/colorScheme";
import { contactWebsite } from "@/configs/contactInformation";
import { useEnv } from "@/hooks/useEnv";
import { isDefined } from "@/utils/format";
import Icon from "@/utils/icons";

import styles from "./LayoutPromo.module.css";

const LayoutAside = () => {
  const theme = useMantineTheme();
  const { t } = useTranslation();

  const randomImageNumber = `0${Math.floor(Math.random() * 9) + 1}`;
  const backgroundImage = new URL(`/src/assets/backgrounds/${randomImageNumber}.jpg`, import.meta.url).href;

  const supabaseUrl = useEnv("VITE_SUPABASE_URL");
  const logo =
    isDefined(supabaseUrl) && isDefined(theme.other.logo) ? supabaseUrl + theme.other.logo : theme.other.logoLocal;

  return (
    <BackgroundImage src={backgroundImage} h="100%">
      <Image src={logo} h={72} w="auto" ml={48} pt={24} />
      <Center h="90%">
        <Container size="sm" className={styles["card-blurred"]}>
          <Stack align="center" justify="center" gap="xl">
            <Container size="xs" pt="xl">
              <Stack align="center" justify="center" gap="xl">
                <Title order={1}>{t("registration.product-promo-title")}</Title>
                <Text>{t("registration.product-promo-description")}</Text>
                <Button
                  component="a"
                  color={SYSTEM_COLORS.primary}
                  href={contactWebsite}
                  rightSection={<Icon.GO_FORWARD />}
                >
                  {t("registration.learn-more")}
                </Button>
              </Stack>
            </Container>
            <Image src={promoImage} />
          </Stack>
        </Container>
      </Center>
    </BackgroundImage>
  );
};

export default LayoutAside;
